import {
  accountSearchColumns,
  khachHangSearchColumns,
  QUERY_KEYS,
  thueSearchColumns,
  tinhChatThueSearchColumns
} from '@/constants';
import { AccountModel, KhachHang, Tax, TinhChatThue } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface TaxTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export default function TaxTab({ formMode, formState: { state, actions } }: TaxTabProps) {
  return (
    <div className='p-4'>
      <div className='flex flex-col'>
        <div className='flex items-center'>
          <Label className='w-32 font-medium'>Mẫu báo cáo</Label>
          <div className='w-[400px]'>
            <FormField
              name='ma_mau_bc'
              type='select'
              disabled={formMode === 'view'}
              options={[
                { value: '3', label: '3. Hoá đơn giá trị gia tăng' },
                { value: '4', label: '4. Hàng hoá, dịch vụ mua vào không có hoá đơn' },
                { value: '5', label: '5. Hoá đơn bán hàng thông thường' }
              ]}
              className='ml-1'
            />
          </div>
        </div>

        {/* Mã tính chất */}
        <div className='flex items-center'>
          <Label className='w-32 font-medium'>Mã tính chất</Label>
          <SearchField<TinhChatThue>
            type='text'
            name='ma_thue'
            value={state.tinhChatThue?.ten_tc_thue || ''}
            searchEndpoint={`/${QUERY_KEYS.TINH_CHAT_THUE}/`}
            searchColumns={tinhChatThueSearchColumns}
            columnDisplay='ten_tc_thue'
            dialogTitle='Danh mục thuế'
            onRowSelection={actions.setTinhChatThue}
            disabled={formMode === 'view'}
            className='w-100'
          />
        </div>

        {/* Mã thuế */}
        <div className='flex items-center'>
          <Label className='w-32 font-medium'>Mã thuế</Label>
          <SearchField<Tax>
            type='text'
            name='ma_thue'
            value={state.taxModel?.ma_thue || ''}
            relatedFieldValue={state.taxModel?.ten_thue || ''}
            searchEndpoint={`/${QUERY_KEYS.THUE}/`}
            searchColumns={thueSearchColumns}
            columnDisplay='ma_thue'
            displayRelatedField='ten_thue'
            dialogTitle='Danh mục thuế'
            onRowSelection={actions.setTaxModel}
            disabled={formMode === 'view'}
            className='w-100'
          />
        </div>

        {/* TK thuế */}
        <div className='flex items-center'>
          <Label className='w-32 font-medium'>TK thuế</Label>
          <SearchField<AccountModel>
            type='text'
            name='tk_thue'
            value={state.taiKhoanThue?.code || ''}
            relatedFieldValue={state.taiKhoanThue?.name || ''}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={accountSearchColumns}
            columnDisplay='code'
            displayRelatedField='name'
            dialogTitle='Danh mục tài khoản'
            onRowSelection={actions.setTaiKhoanThue}
            disabled={formMode === 'view'}
            className='w-100'
          />
        </div>

        {/* Cục thuế */}
        <div className='flex items-center'>
          <Label className='w-32 font-medium'>Cục thuế</Label>
          <SearchField<KhachHang>
            type='text'
            name='ma_kh9'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            searchColumns={khachHangSearchColumns}
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            dialogTitle='Danh mục tài khoản'
            disabled={formMode === 'view'}
            value={state.cucThue?.customer_code || ''}
            relatedFieldValue={state.cucThue?.customer_name || ''}
            onRowSelection={actions.setCucThue}
            className='w-100'
          />
        </div>

        {/* Nhóm sản phẩm */}
        <div className='w-full'>
          <FormField
            label='Nhóm sản phẩm'
            name='ten_vt_thue'
            type='text'
            disabled={formMode === 'view'}
            labelClassName='font-medium w-32'
          />
        </div>

        {/* Ghi chú */}
        <div className='w-full'>
          <FormField
            label='Ghi chú'
            name='ghi_chu'
            type='text'
            disabled={formMode === 'view'}
            labelClassName='font-medium w-32'
          />
        </div>

        {/* Kê thuế đầu ra */}
        <div className='flex items-center pt-2'>
          <Label className='w-32 font-medium'>Kê thuế đầu ra</Label>
          <FormField name='outvat_yn' type='checkbox' disabled={formMode === 'view'} labelClassName='w-32' />
        </div>
      </div>
    </div>
  );
}
